var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMinor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ljoumxzrja",
    y1: 0.5,
    x2: 1.183,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e3e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1981",
    transform: "translate(-381.938 -490.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 80",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(381.938 490.5)",
    style: {
      fill: "url(#ljoumxzrja)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 296",
    transform: "translate(389.938 507.5)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.99,
    height: 2.221,
    rx: 1.111,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 17.99,
    height: 0.221,
    rx: 0.111,
    style: {
      fill: "none"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMinor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-minor.273180341ffebadbb4851c090b3088be.svg";